import { CSSObject } from '@emotion/react'
import { colors } from '../../styles'

export const cssFineDineInButton: CSSObject = {
  color: colors.s200,
  ['&:hover']: {
    color: colors.bluecheese,
    cursor: 'pointer',
  },
}
